import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { isNull, omit } from 'lodash'
import { Link } from 'react-router-dom'
import Button from 'material-ui-next/Button'
import RaisedButton from 'material-ui/RaisedButton'
import ListCard from '../../common/ListCard'
import NoResults from '../../common/NoResults'
import ListCardVirtual from '../../common/ListCardVirtual'
import withTopBar from '../../common/TopBar/withTopBar'
import {
  loadOwnedItems,
  loadMoreOwnedItems,
  unloadOwnedItems,
  putOwnedItemsInCache,
} from '../../actions'
import {
  getOwnedItems,
  canLoadMoreOwnedItems,
  getTotalOwnedItems,
  getOwnedItemsLoading,
  getOwnedItemsScrollToIndex,
} from '../../selectors'
import {
  parseQ,
  itemLink,
  getLocationKey,
  adjustScrollToIndex,
} from '../../utils'

class ListCardOwned extends PureComponent {
  handleSwapClick = e => {
    e.stopPropagation()
    this.props.onSwapClick(this.props.item, this.props.index)
  }

  render() {
    return (
      <ListCard
        {...omit(this.props, 'onSwapClick')}
        rightButton={
          <Button color="primary" onClick={this.handleSwapClick}>
            Scambia
          </Button>
        }
      />
    )
  }
}

class OwnedItems extends PureComponent {
  state = {
    scrollToIndex: undefined,
  }

  componentDidMount() {
    const { items, scrollToIndex } = this.props
    if (scrollToIndex && items) {
      // Living in a life of workaround
      this.setState({
        scrollToIndex: adjustScrollToIndex(scrollToIndex, items.length),
      })
    }
    this.props.loadOwnedItems(
      {
        q: this.props.searchString,
      },
      getLocationKey(this.props.location)
    )
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.searchString !== nextProps.searchString) {
      this.props.unloadOwnedItems()
      this.search(nextProps.searchString)
    }
  }

  componentWillUnmount() {
    this.props.unloadOwnedItems(false)
  }

  componentDidUpdate(prevProps, prevState) {
    // Scroll resetted can now purge it!
    if (prevState.scrollToIndex) {
      this.setState({ scrollToIndex: undefined })
    }
  }

  search(searchString) {
    this.props.loadOwnedItems({
      q: searchString,
    })
  }

  loadMore = () => {
    this.props.loadMoreOwnedItems({
      q: this.props.searchString,
    })
  }

  goToItemDetail = (item, index) => {
    this.props.putOwnedItemsInCache({
      index,
      cacheKey: getLocationKey(this.props.location),
    })
    this.props.history.push(itemLink(item))
  }

  goToItemsICanGet = (item, index) => {
    this.props.putOwnedItemsInCache({
      index,
      cacheKey: getLocationKey(this.props.location),
    })
    this.props.history.push(`/me/items/can-get?item=${item.id}`)
  }

  renderNoRows = () => {
    const { items, loading, searchString } = this.props

    if (!loading && !isNull(items) && items.length === 0) {
      if (searchString === '') {
        // No items owned
        return (
          <NoResults>
            <p>Non possiedi ancora nessun oggetto</p>
            <RaisedButton
              containerElement={<Link to={`/add`} />}
              label="Aggiungi un oggetto"
              primary={true}
            />
          </NoResults>
        )
      } else {
        // No results for searching
        return (
          <NoResults>
            Nessun oggetto per la ricerca <b><i>{searchString}</i></b>
          </NoResults>
        )
      }
    }
    return null
  }

  render() {
    const { items, loading, canLoadMoreItems } = this.props
    return (
      <ListCardVirtual
        items={items}
        loading={loading}
        canLoadMoreItems={canLoadMoreItems}
        loadMore={this.loadMore}
        scrollToIndex={this.state.scrollToIndex}
        noRowsRenderer={this.renderNoRows}
        renderListCard={(item, index) => (
          <ListCardOwned
            item={item}
            index={index}
            onClick={this.goToItemDetail}
            onSwapClick={this.goToItemsICanGet}
          />
        )}
      />
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  // Parse the query string ?q= into a string take care of null boring stuff
  searchString: parseQ(ownProps.location),
  items: getOwnedItems(state, getLocationKey(ownProps.location)),
  totalItems: getTotalOwnedItems(state),
  canLoadMoreItems: canLoadMoreOwnedItems(state),
  loading: getOwnedItemsLoading(state),
  scrollToIndex: getOwnedItemsScrollToIndex(
    state,
    getLocationKey(ownProps.location)
  ),
})

export default withTopBar({
  toolbar: 'ItemsToolbar',
  title: 'Lista possiedo',
})(
  connect(mapStateToProps, {
    loadOwnedItems,
    loadMoreOwnedItems,
    unloadOwnedItems,
    putOwnedItemsInCache,
  })(OwnedItems)
)



// WEBPACK FOOTER //
// ./src/pages/Me/OwnedItems.js